import { ReactElement, ReactNode } from 'react'

import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dialog } from '@headlessui/react'
import { msg } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import Title from 'Root/App/Title'
import Button from 'Root/Component/Button'

interface Props {
  children: ReactNode
  title: string | ReactElement
  cta?: ReactNode
  onClose: () => void
}

const PanelLayout: React.FC<Props> = ({ children, title, cta, onClose }) => {
  const { _ } = useLingui()

  return (
    <span className="flex flex-col gap-4 overflow-y-auto sm:gap-6">
      <Dialog.Title className="flex items-center justify-between">
        <Title>{title}</Title>
        <Button
          variant="text"
          size="sm"
          iconOnly
          aria-label={_(msg`Chiudi`)}
          iconLeft={<FontAwesomeIcon icon={faXmark} />}
          onClick={onClose}
        />
      </Dialog.Title>

      {children}

      {cta && (
        <span className="flex gap-6 justify-end mt-2 w-full sm:mt-3">
          {cta}
        </span>
      )}
    </span>
  )
}

export default PanelLayout
